(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/joker/joker-huxflux-row.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/joker/joker-huxflux-row.js');

'use strict';

svs.numbergames.game.views.JokerHuxfluxRow = Marionette.View.extend({
  className: 'joker-row-input-position joker-row grid-container-inner gutter-xs-0',
  regions: {
    jokerBallRowRegion: '#jokerBallRowRegion'
  },
  ui: {
    ballRow: '.js-joker-ball-row',
    huxfluxBtn: '.js-joker-huxflux-btn'
  },
  triggers: {
    'click @ui.ballRow': 'ballRowClicked',
    'click @ui.huxfluxBtn': 'huxfluxJoker'
  },
  behaviors: [svs.numbergames.accessibility.behaviors.UIFocusDisable 
  ],

  modelEvents: {
    'change:jokerRow': 'onChangeJokerRow'
  },
  template(data) {
    return svs.numbergames.game.templates.joker_row(data);
  },
  initialize() {
    if (!this.model.has('jokerRow') || !this.model.get('jokerRow').length) {
      this.model.set({
        jokerRow: svs.numbergames.rules.joker.getHuxfluxedRow()
      });
    }
    this.ballRow = new svs.tur.ball.row.Joker({
      numbers: this.model.getJokerRowAsArray()
    });
    this.ballRow.on(svs.tur.ball.constants.HUXFLUX_STARTED, () => {
      this.trigger('disableUI', this.getUI('huxfluxBtn'));
    }, this);
    this.ballRow.on(svs.tur.ball.constants.HUXFLUX_COMPLETED, () => {
      this.trigger('enableUI', this.getUI('huxfluxBtn'));
    }, this);
  },
  onRender() {
    this.showChildView('jokerBallRowRegion', () => this.ballRow.render());
  },
  onAttach() {
    this.animations = svs.numbergames.game.animations.joker.getRowAnimations({
      wrapperEl: this.$el,
      rowEl: this.getChildView('jokerBallRowRegion').$el,
      huxfluxBtnEl: this.getUI('huxfluxBtn'),
      callbackScope: this,
      onHide() {
        this.constructor.__super__.destroy.apply(this);
      }
    });
    this.animations.show();
  },
  onHuxfluxJoker() {
    this.model.set({
      jokerRow: svs.numbergames.rules.joker.getHuxfluxedRow()
    });
  },
  onChangeJokerRow(model) {
    this.ballRow.prepare(model.getJokerRowAsArray());
    this.ballRow.huxflux();
  },
  destroy() {
    this.animations.hide();
  },
  onDestroy() {
    this.ballRow.off(svs.tur.ball.constants.HUXFLUX_STARTED, this);
    this.ballRow.off(svs.tur.ball.constants.HUXFLUX_COMPLETED, this);
  }
});

 })(window);